import React from "react";
import "./loader.scss";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <span className="loader" />
    </div>
  );
};

export { Loader };
